import {Outlet} from "react-router-dom";
import {Header} from "./components/Header";
import {Footer} from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-full flex flex-col">
      <Header />
      <main className="flex-1 mx-auto w-full max-w-[1440px] px-6 py-8">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
